import FaqAccordion from "@/components/feature/FaqAccordion";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              kicker="常见问题"
              title="关于围观，你可能想问"
              desc="关于内容来源、热度数据、投稿方式和更新节奏，我们把被问得最多的问题整理在这里。"
            />
            <div className="mt-6 rounded-lg bg-secondary-50 border border-secondary-200/70 p-5">
              <p className="text-sm text-foreground-700 leading-relaxed">
                没找到答案？欢迎把问题发到我们的邮箱，编辑会尽量一一回复，也会把高频问题补充到这里。
              </p>
              <a
                href="mailto:hello@reguaqianxian.com"
                className="mt-3 inline-flex items-center gap-2 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                hello@reguaqianxian.com
              </a>
            </div>
          </div>
          <div className="lg:col-span-7">
            <FaqAccordion />
          </div>
        </div>
      </div>
    </section>
  );
}